<template>
  <div>
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-card-actions
        title="Filters"
        action-collapse
        collapsed
      >
        <b-row>
          <b-col
            md="3"
          >
            <b-form-group
              label="Employee ID"
              label-for="reference_id"
            >
              <b-form-input
                id="reference_id"
                v-model="tempFilters['reference_id']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="First Name"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="tempFilters['first_name']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="Email"
              label-for="v-name"
            >
              <b-form-input
                id="v-name"
                v-model="tempFilters['email']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="NIC Number"
              label-for="nic"
            >
              <b-form-input
                id="nic"
                v-model="tempFilters['nic']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            md="3"
          >
            <b-form-group
              label="Address"
              label-for="address"
            >
              <b-form-input
                id="address"
                v-model="tempFilters['address']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="3"
          >
            <b-form-group
              label="Assigned Warehouse"
              label-for="assigned_warehouse"
            >
              <v-select
                id="assigned_warehouse"
                v-model="tempFilters['warehouse_id']"
                :options="warehouseOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Warehouse"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1">
          <b-col>
            <filter-buttons
              :filter-data="tempFilters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </b-card-actions>
      <b-card>
        <b-tabs
          ref="staffTabBar"
          v-model="selectedRoleIndex"
          card
          pills
          @input="onTabSelect"
        >
          <b-tab
            v-for="(role, index) in roles"
            :key="role.id"
          >
            <template #title>
              <span class="font-weight-bold">
                {{ role.name }}
              </span>
            </template>
            <staff-list
              v-if="selectedRoleIndex === index"
              :role="selectedRole"
              :filters="filters"
            />
          </b-tab>
          <b-tab v-if="roles.length > 0">
            <template #title>
              <span class="font-weight-bold">
                All
              </span>
            </template>
            <staff-list
              v-if="selectedRoleIndex === roles.length"
              ref="StaffList"
              :role="selectedRole"
              :filters="filters"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BOverlay,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@core/mixins/filter'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import StaffList from './StaffList.vue'

const RoleRepository = RepositoryFactory.get('role')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BOverlay,
    StaffList,
    BCardActions,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  data() {
    return {
      roles: [],
      selectedRole: null,
      selectedRoleIndex: 0,
      loading: false,
      filters: {},
      warehouseOptions: [],
      filterOn: [],
      tempFilters: {},
    }
  },
  async mounted() {
    await this.fetchRoleList()
    // eslint-disable-next-line no-underscore-dangle
    this.__preserveTabOnRefresh('staffTabBar', 'staffTabIndex')
    await this.getWarehouseList()
  },
  methods: {
    async fetchRoleList() {
      try {
        this.loading = true
        const { data } = (await RoleRepository.getRoleListNoPagination())
        this.roles = data.data
        // load super admin role details
        if (this.roles.length > 0) {
          await this.loadRoleData(this.roles[0])
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async onTabSelect(index) {
      this.selectedRoleIndex = index
      if (index === this.roles.length) {
        // Load all staff members when "All" tab is clicked
        await this.loadAllStaffData()
      } else {
        const selectedRole = this.roles[index]
        await this.loadRoleData(selectedRole)
      }
    },
    async loadRoleData(role) {
      try {
        this.loading = true
        this.selectedRole = role
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async loadAllStaffData() {
      try {
        this.loading = true
        this.selectedRole = null
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async getWarehouseList() {
      try {
        this.warehouseOptions = localStorage.getItem('warehouse_list') ? JSON.parse(localStorage.getItem('warehouse_list')) : (await ResourceRepository.getWarehouseListForDropDown()).data.data
        if (!localStorage.getItem('warehouse_list')) localStorage.setItem('warehouse_list', JSON.stringify(this.warehouseOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    applyFilters() {
      this.filters = { ...this.tempFilters }
      this.selectedRoleIndex = this.roles.length
      this.selectedRole = null
      // Wait for tab change, then fetch filtered data
      this.$nextTick(() => {
        if (this.$refs.staffTabBar) {
          this.$refs.staffTabBar.activateTab(this.selectedRoleIndex)
        }
      })
    },
    clearFilters() {
      this.tempFilters = {}
      this.filters = {}
      this.selectedRoleIndex = this.roles.length
      this.selectedRole = null
    },
  },
}
</script>
<style scoped>
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
</style>
